import React from 'react'
import NetherlandBloreMain from './NetherlandBloreMain'
import "./../../UaeAttestation/UaeBlore/UaeBlore.css";
import UaeBloreHead from "../../UaeAttestation/UaeBlore/UaeBloreHead";
const NetherlandBlore = () => {
  return (
    <div className="uaeBloreContainer">
    <UaeBloreHead head="Netherland Apostille in Bangalore" />
    <NetherlandBloreMain />
  </div>
  )
}

export default NetherlandBlore
